import { createReducer } from 'redux-create-reducer';
import {
  updateInterventionTimeAction,
  updateInterventionTimeUnitAction,
  updatePlanningDateAction,
  updatePlanningTimeAction,
  updatePreplanningDateAction,
  updateSecondaryWorkerIdsAction,
  updateWorkerIdAction,
  updatePlanifConstraintsAction,
  updateInternalCommentAction,
  requestFormAction,
  receiveFormAction,
} from '../actions/form';

const initialState = {
  planningDate: undefined,
  planningTime: undefined,
  preplanningDate: undefined,
  interventionTime: undefined,
  interventionTimeUnit: undefined,
  primaryWorkerId: undefined,
  secondaryWorkerIds: [],
  planifConstraints: undefined,
  internalComment: undefined,
  status: undefined,
  isFetching: false,
  errors: [],
};

const ERRORS = 'errors';

export const formReducer = createReducer(initialState, {
  [updatePlanningDateAction](state, action) {
    return {
      ...state,
      planningDate: action.payload,
    };
  },
  [updatePlanningTimeAction](state, action) {
    return {
      ...state,
      planningTime: action.payload,
    };
  },
  [updatePreplanningDateAction](state, action) {
    return {
      ...state,
      preplanningDate: action.payload,
    };
  },
  [updateInterventionTimeAction](state, action) {
    return {
      ...state,
      interventionTime: action.payload,
    };
  },
  [updateInterventionTimeUnitAction](state, action) {
    return {
      ...state,
      interventionTimeUnit: action.payload,
    };
  },
  [updateWorkerIdAction](state, action) {
    return {
      ...state,
      workerId: action.payload,
    };
  },
  [updateSecondaryWorkerIdsAction](state, action) {
    return {
      ...state,
      secondaryWorkersIds: action.payload,
    };
  },
  [updatePlanifConstraintsAction](state, action) {
    return {
      ...state,
      planifConstraints: action.payload,
    };
  },
  [updateInternalCommentAction](state, action) {
    return {
      ...state,
      internalComment: action.payload,
    };
  },
  [requestFormAction](state) {
    return {
      ...state,
      isFetching: true,
    };
  },
  [receiveFormAction](state, action) {
    return {
      ...state,
      ...action.payload,
      errors: [],
      isFetching: false,
    };
  },
  [ERRORS](state, action) {
    return {
      ...state,
      errors: action.payload,
    };
  },
});

export default formReducer;

export const getErrors = state => state.form.errors;
export const getPlanningDate = state => state.form.planningDate;
export const getPlanningTime = state => state.form.planningTime;
export const getPreplanningDate = state => state.form.preplanningDate;
export const getInterventionTime = state => state.form.interventionTime;
export const getInterventionTimeUnit = state => state.form.interventionTimeUnit;
export const getPrimaryWorkerId = state => state.form.workerId;
export const getSecondaryWorkerIds = state => state.form.secondaryWorkersIds;
export const getPlanifConstraints = state => state.form.planifConstraints;
export const getInternalComment = state => state.form.internalComment;
export const getStatus = state => state.form.status;



// WEBPACK FOOTER //
// ./src/modules/saas/aast/interventions/reducers/form.js